import { render, staticRenderFns } from "./KrausSelect.vue?vue&type=template&id=a3e4c544&lang=pug&"
import script from "./KrausSelect.vue?vue&type=script&lang=js&"
export * from "./KrausSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports